import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tceVendorStru',
    standalone: false
})
export class TceVendorStruPipe implements PipeTransform {

  public transform(
    tceArr: any[],
    legId: number,
    sector: string,
    lastLeg: boolean,
  ) {
    legId = Number(legId);
    // Extract station ICAOs
  const originIcao = sector.substr(0, 4);
  const destIcao = sector.split('-')[1];
  const legIDServiceArray = tceArr.filter((item: any) => item.legId === legId);
  // If origin and destination are same, custom logic
  if (originIcao === destIcao) {
  const result: any = {};
  // Vendors for Origin/Departure
  // result[`${originIcao}`] = legIDServiceArr.filter(item => item.flagOriginDestination === 'Origin' && item.stationType === 'same');
  result[`${originIcao}`] = legIDServiceArray.filter(item => item.stationType === 'same');
  // Vendors for Sector-Level (entire leg)
  result[`${originIcao}-${destIcao}`] = legIDServiceArray.filter(item => item.station === `${originIcao}-${destIcao}`);

  // Vendors for Destination/Arrival
  // result[`${destIcao}-Destination`] = legIDServiceArr.filter(item => item.flagOriginDestination === 'Destination' && item.stationType === 'same');
    const priceKey = 'price';
  // Price logic for all keys
  result[priceKey] = {};
  [ `${originIcao}`, `${originIcao}-${destIcao}` ].forEach(key => {
    result[priceKey][key] = [];
    let total = 0;
    result[key].forEach(vendor => {
      if (vendor.UID === vendor.vendorId) {
        result[priceKey][key][0] = 'self';
      } else {
        total += vendor.price || 0;
      }
    });
    if (result[priceKey][key][0] !== 'self') {
      result[priceKey][key][0] = total;
    }
  });

  return [result];
  }  else {
    let servicesArr = new Array<any>();
    let legIDServiceArr = new Array<any>();
    legIDServiceArr = tceArr.filter((item: any) => {
      return item.legId == legId;
    });
    let firstStationArr = new Array<any>();
    firstStationArr = legIDServiceArr.filter((item: any) => {
      return item.station == sector.substr(0, 4);
    });
    let sectorArr = new Array<any>();
    sectorArr = legIDServiceArr.filter((item: any) => {
      return item.station == sector;
    });
    const secondStationArr = legIDServiceArr.filter((item: any) => {
      return item.station == sector.split("-")[1];
    });
    servicesArr = servicesArr.concat(firstStationArr);
    servicesArr = servicesArr.concat(sectorArr);
    if (lastLeg) {
      servicesArr = servicesArr.concat(secondStationArr);
    }
    const finalArr = {
      price: [],
    };
    servicesArr.forEach((element: any) => {
      if (!finalArr[element.station]) {
        finalArr[element.station] = [];
      }
      finalArr[element.station].push(element);
      if (finalArr.price[element.station]) {
        if (element.UID != element.vendorId) {
          if (finalArr.price[element.station][0] == "self") {
            finalArr.price[element.station][0] = 0;
            finalArr.price[element.station][0] += element.price || 0;
          } else {
            finalArr.price[element.station][0] += element.price || 0;
          }
        }
      } else {
        finalArr.price[element.station] = [];
        if (element.UID != element.vendorId) {
          finalArr.price[element.station][0] = element.price || 0;
        } else {
          finalArr.price[element.station][0] = "self";
        }
      }
    });
    const vendorArr = [];
    vendorArr.push(finalArr);
    for (const stations in vendorArr[0]) {
      if (stations != sector) {
        vendorArr[0][stations].forEach((element: any) => {
          switch (element.serviceName) {
            case "handling":
              element.order = 1;
              break;
            case "fuel":
              element.order = 2;
              break;
            case "airportcharges":
              element.order = 3;
              break;
          }
        });
        vendorArr[0][stations].sort((a, b) => {
          return a.order - b.order;
        });
        this.deleteOrder(vendorArr[0][stations]);
      }
    }
      return vendorArr;
  }
  }
  public deleteOrder(stationArr: any) {
    stationArr.forEach((element: any) => {
      delete element.order;
    });
  }

}
